import React, { useState } from 'react';
import './Video-component.css';

const VideoComponent = () => {
  // Sample video data - you would replace this with your actual videos
  const videoList = [
    {
      id: "aegYT3QzKK0",
      si: "BiEhRsYBNK--KVGL",
      title: "YouTube video player",
      displayName: "Gaming Performance | Galaxy S25 Ultra | Samsung"
    },
    {
      id: "aegYT3QzKK0",
      si: "8cxbmzvysJTHDKAj",
      title: "YouTube video player",
      displayName: "Gaming Performance | Galaxy S25 Ultra | Samsung"
    },
    {
      id: "-56H-zQg76M",
      si: "guekEoPujZLzZ8Oi",
      title: "YouTube video player",
      displayName: "Galaxy AI | Portrait | Galaxy S25 Ultra | Samsung"
    },
    
  ];

  // State to track the currently selected video
  const [currentVideo, setCurrentVideo] = useState(videoList[0]);

  // Function to handle video selection
  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
  };

  return (
    <div className="youtube-container">
      {/* Left container - Video List */}
      <div className="video-list-container">
        <div className='video-list-header'>
          <h2 className="video-list-title">Video</h2>
          <p>{videoList.length} Videos</p>
        </div>

        <ul className="video-list">
          {videoList.map((video) => (
            <li
              key={video.id}
              className={`video-list-item ${currentVideo.id === video.id ? 'active' : ''}`}
              onClick={() => handleVideoSelect(video)}
            >
              <img src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} alt="" />
              <h6 className="video-item-title">{video.displayName}</h6>
            </li>
          ))}
        </ul>
      </div>

      {/* Right container - Video Player */}
      <div className="video-player-container">
        <div className="video-frame-container">
          <iframe
            className="video-frame"
            src={`https://www.youtube.com/embed/${currentVideo.id}?si=${currentVideo.si}`}
            title={currentVideo.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoComponent;